import {
  apiGet, apiPost,
} from '~/_shared/utils/api/api.helpers';
import type { PasswordErrorType } from '~/authentication/passwordResetPage/passwordErrorType';

type AuthenticationResponse = {
  message: string;
  refresh?: string;
  access_token_expiration?: string;
};

type CompleteRegistrationResponse = {
  message: string;
  errors?: {
    password?: (PasswordErrorType | string)[];
  };
};

type SalesforceAuthResponse = Readonly<{
  redirect_uri: string;
}>;

export const authenticateSalesforceUser = (token: string): Promise<AuthenticationResponse> => {
  const url = `api/auth/sign-in-link/${token}`;

  return apiPost(url);
};

export const completeSalesforceRegistration = (token: string, password: string, passwordConfirmation: string): Promise<CompleteRegistrationResponse> => {
  const url = '/api/auth/register/salesforce/complete';

  return apiPost(url, {
    token,
    password,
    password_confirmation: passwordConfirmation,
  });
};

export const salesforceAuth = ({
  clientId,
  redirectUri,
  responseType,
  state,
}: {
  clientId: string;
  redirectUri: string;
  responseType: string;
  state: string;
}): Promise<SalesforceAuthResponse> => {
  const url = `/salesforce?client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=${responseType}&state=${encodeURIComponent(state)}`;
  return apiGet(url);
};
